import {Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {StyledContainer, StyledUnOrderList} from './styles';

const {line1, topics} =
	translations['pt-br'].privateFlow.myHospitalization.generalOrientations.cards.extendedVisit;

export const ExtendedVisit = () => (
	<StyledContainer>
		<Typography variant="body1">{line1}</Typography>
		<StyledUnOrderList>
			{Object.values(topics).map((text, index) => (
				<li key={index}>
					<Typography variant="body1">{text}</Typography>
				</li>
			))}
		</StyledUnOrderList>
	</StyledContainer>
);
